export const sanitizeText = (input) => {
    if (typeof input !== 'string') {
        return '';
    }

    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(input, 'text/html');

    return parsedDocument.body.textContent || '';
};

